import { Selections, EachWayOptions, BetTypes } from "./bet-types.js";

jQuery(document).ready(function ($) {

  
      function openTooltip(x = null) {
        
        if(!windowWidth.matches){
          return;
        }

        $(this).addClass('active');
        var tooltipContent = $(this).attr('data-title');
        tooltipContent = '<span class="tooltip-wrap">'+tooltipContent+'</span>';
        $(this).append(tooltipContent);
      
      }
      
      function closeTooltip() {
            
        if(!windowWidth.matches){
          return;
        }

        $(this).removeClass('active');
        $(this).find('span').remove();
      
      }

      function mobileTooltip(){

        if($(this).hasClass('active')){

          $(this).removeClass('active');
          $(this).find('span').remove();

        }
        else{

          $(this).addClass('active');
          var tooltipContent = $(this).attr('data-title');
          tooltipContent = '<span class="tooltip-wrap">'+tooltipContent+'</span>';
          $(this).append(tooltipContent);

        }

      }

      var windowWidth = window.matchMedia("(min-width: 1024px)");
      $('[data-toggle="tooltip"]').hover(openTooltip, closeTooltip);
      $('[data-toggle="tooltip"]').click(mobileTooltip);


      //GLOBALS
      let numberOfRows = 1;
      let betCount = 0;
      let totalReturn = 0;
      let applyRuleFour = false;
      let applyEachWay = false;
      let betType = $("#betTypeSelectionBox").val();
      let eachWayOption = $("#eachWayListBox").val();
      let selectionCountParentElement = $("#selectionCount").parent().parent();
      let foldOptionsParentElement = $("#foldOptions").parent().parent();
      let multipleEachWayListBoxParentElement = $("#multipleEachWayListBox").parent().parent();
      let anyToComeEachWayListBoxParentElement = $("#anyToComeEachWayListBox").parent().parent();
      let allWinnersBonusParentElement = $("#allWinnerBonus").parent().parent();
      let oneLoserBonusParentElement = $("#oneLoserBonus").parent().parent();
      let oneWinnerConsolationParentElement = $("#oneWinnerConsolation").parent().parent();
  

      let disableTooltip = false;
      let selectedInputId = "";

      $(document).on("click", function(event){
        if($(event.target).is("select") && ( !disableTooltip || selectedInputId !== $(event.target).attr("id"))) {
         selectedInputId = $(event.target).attr("id")
          disableTooltip = true;
          $("button").prop("disabled",disableTooltip);
          return;
        }
        disableTooltip = false;
        $("button").prop("disabled", disableTooltip);
      });

      let oddsSelectionRows = [];
      let foldRows = [];
    
      //ROWS MANIPULATIONS
      const baseRows = $("#oddSelectionTableBody > tr");
      const baseFoldRow = $("#foldTableBody > tr");
    
      oddsSelectionRows.push(...baseRows);
      foldRows.push(...baseFoldRow);

      const seedRows = () => {
        //SEED MAIN ODDS SELECTIONS ROWS
        for (let i = 2; i <= 20; i++) {
          let newRow = [];
          newRow[0] = $(baseRows[0]).clone();
          newRow[1] = $(baseRows[1]).clone();
          newRow[2] = $(baseRows[2]).clone();
          $(newRow[1]).find(".row-num-outcome").text(i);
          $(newRow[0]).find(".row-num-note").text(i);
          oddsSelectionRows.push(...newRow);
    
          //SEED FOLD ROWS
          let newFoldRow = $(foldRows[0]).clone();
          switch (i) {
            case 2:
              $(newFoldRow).find(".fold-type").text("Double");
              break;
            case 3:
              $(newFoldRow).find(".fold-type").text("Treble");
              break;
            default:
              $(newFoldRow).find(".fold-type").text(`${i}-Fold`);
          }
          foldRows.push(...newFoldRow);
        }
      };
      seedRows();
      
      const removeRows = () => {
        saveRowsState();
        $("#oddSelectionTableBody > tr").remove();
        $("#foldTableBody > tr").remove();
      };
    
      const showRows = () => {
        removeRows();
        oddsSelectionRows.slice(0, numberOfRows * 3).map((row) => {
          $("#oddSelectionTableBody").append(row);
        });
    
        foldRows.slice(0, numberOfRows).map((row) => {
          $("#foldTableBody").append(row);
        });
      };
    
      const saveRowsState = () => {
        let count = 0;
        let currentRows = $("#oddSelectionTableBody > tr");
        
        $(currentRows).each(function () {
          oddsSelectionRows[count] = $(this);
          count++;
        });
    
        count = 0;
        let currentFoldRows = $("#foldTableBody > tr");
        $(currentFoldRows).each(function () {
          foldRows[count] = $(this);
          count++;
        });
      };
    
      const getStake = () => {
        return Number($("#stake").val());
      };

      const hideTableOption = (optionName, optionClass) => {
        oddsSelectionRows.map((row) => {
          $(row)
            .find("." + optionClass)
            .parent()
            .hide();
        });
        $(
          `.main-selections-table > thead > tr > th:contains(${optionName})`
        ).hide();
      };
    
      const showTableOption = (optionName, optionClass) => {
        oddsSelectionRows.map((row) => {
          $(row)
            .find("." + optionClass)
            .parent()
            .show();
        });
        $(
          `.main-selections-table > thead > tr > th:contains(${optionName})`
        ).show();
      };
    
      const showSelections = () => {
        Selections.selectionCount.includes(betType)
          ? selectionCountParentElement.show()
          : selectionCountParentElement.hide();
    
        Selections.foldOptions.includes(betType)
          ? foldOptionsParentElement.show()
          : foldOptionsParentElement.hide();
    
        if (applyEachWay) {
          allWinnersBonusParentElement.hide();
          return;
        }
    
        if (Selections.allWinnersBonus.includes(betType)) {
          allWinnersBonusParentElement.show();
        //   allWinnersBonusParentElement.parent().show();
        } else {
          allWinnersBonusParentElement.hide();
        //   allWinnersBonusParentElement.parent().hide();
        }
    
        Selections.oneLoserBonus.includes(betType)
          ? oneLoserBonusParentElement.show()
          : oneLoserBonusParentElement.hide();
    
        Selections.oneWinnerConsolation.includes(betType)
          ? oneWinnerConsolationParentElement.show()
          : oneWinnerConsolationParentElement.hide();
      };
      showSelections(betType);
    
      const showEachWayOptions = () => {
        if (eachWayOption === "2") {
          EachWayOptions.multiple.includes(betType)
            ? multipleEachWayListBoxParentElement.show()
            : multipleEachWayListBoxParentElement.hide();
    
          EachWayOptions.anyToCome.includes(betType)
            ? anyToComeEachWayListBoxParentElement.show()
            : anyToComeEachWayListBoxParentElement.hide();
        } else {
          multipleEachWayListBoxParentElement.hide();
          anyToComeEachWayListBoxParentElement.hide();
        }
      };
      showEachWayOptions();
    
      const calculateSSA = (result, stake) => {
        let final = 0;
        if (result[0] > 0) {
          let firstBet = result[0] * stake;
          let secondPartStake = 0;
    
          if (betType === "DOUBLE_STAKES_ABOUT") {
            secondPartStake = firstBet < stake * 2 ? firstBet : stake * 2;
          } else {
            secondPartStake = firstBet < stake ? firstBet : stake;
          }
    
          if (result[1] > 0) {
            firstBet += result[1] * secondPartStake;
            firstBet -= secondPartStake;
          } else {
            firstBet -= secondPartStake;
          }
          final += firstBet;
        }
    
        if (result[1] > 0) {
          let secondBet = result[1] * stake;
          let secondPartStake = 0;
          if (betType === "DOUBLE_STAKES_ABOUT") {
            secondPartStake = secondBet < stake * 2 ? secondBet : stake * 2;
          } else {
            secondPartStake = secondBet < stake ? secondBet : stake;
          }
          if (result[0] > 0) {
            secondBet += result[0] * secondPartStake;
            secondBet -= secondPartStake;
          } else {
            secondBet -= secondPartStake;
          }
          final += secondBet;
        }
        return [final, 2];
      };
    
      const calculateCombination = (combination, stake, isUpAndDown) => {
        const baseOdds = combination.map((odds) => {
          return odds[0];
        });
    
        if (applyEachWay) {
          const eachWayOdds = combination.map((odds) => {
            return odds[1];
          });
    
          if ($("#multipleEachWayListBox").val() == "1") {
            // if (isUpAndDown) {
            //   const [baseOddsSSATotal, baseOddsSSANumberOfBets] = calculateSSA(
            //     baseOdds,
            //     stake
            //   );
            //   const [eachWayOddsSSATotal, eachWayOddsSSANumberOfBets] =
            //     calculateSSA(eachWayOdds, stake);
            //   return [
            //     baseOddsSSATotal + eachWayOddsSSATotal,
            //     baseOddsSSANumberOfBets + eachWayOddsSSANumberOfBets,
            //   ];
            // }
    
            const baseOddsResult = baseOdds.reduce((a, b) => {
              return a * b;
            });
    
            const baseOddsTotal = baseOddsResult * stake;
    
            const eachWayOddsResult = eachWayOdds.reduce((a, b) => {
              return a * b;
            });
            const eachWayOddsTotal = eachWayOddsResult * stake;
    
            return [baseOddsTotal + eachWayOddsTotal, 2];
          } else {
            let currentStake = stake;
            let betResult = 0;
            combination.forEach((oddsPair) => {
              const mainBet = oddsPair[0] * currentStake;
              const placeBet = oddsPair[1] * currentStake;
              betResult = mainBet + placeBet;
              currentStake = betResult / 2;
            });
            return [betResult, 2];
          }
        }
    
        if (isUpAndDown) {
          const [baseOddsSSATotal, baseOddsSSANumberOfBets] = calculateSSA(
            baseOdds,
            stake
          );
          return [baseOddsSSATotal, baseOddsSSANumberOfBets];
        }
    
        let baseOddsResult = baseOdds.reduce((a, b) => {
          return a * b;
        });
        baseOddsResult *= stake;
        return [baseOddsResult, 1];
      };
    
      function makeCombination(
        input,
        comboLength,
        start,
        stake,
        length,
        isUpAndDown = false
      ) {
        const result = [];
        let finalResult = [0, 0];
    
        result.length = length;
    
        function combine(input, comboLength, start, stake, isUpAndDown = false) {
          if (comboLength === 0) {
            const combinationResult = calculateCombination(
              result,
              stake,
              isUpAndDown
            );
            finalResult[0] += combinationResult[0];
            finalResult[1] += combinationResult[1];
            return;
          }
          for (let i = start; i <= input.length - comboLength; i++) {
            result[result.length - comboLength] = input[i];
            combine(input, comboLength - 1, i + 1, stake, isUpAndDown);
          }
        }
    
        combine(input, comboLength, start, stake, isUpAndDown);
    
        return finalResult;
      }
    
      const getCurrentRows = () => {
        const rowsAsArray = [];
        $("#oddSelectionTableBody > tr").each(function () {
          rowsAsArray.push(this);
        });
        return rowsAsArray;
      };
    
      const getCurrentFoldRows = () => {
        const rowsAsArray = [];
        $("#foldTableBody > tr").each(function () {
          rowsAsArray.push(this);
        });
        return rowsAsArray;
      };
    
      const convertToDecimal = (row) => {
        switch ($("#oddsFormat").val()) {
          case "Decimals":
            return $(row).find(".selection-odds").val();
          case "Fractions":
            let fractionNumbers = [];
            $(row)
              .find(".selection-odds-fraction")
              .each(function () {
                fractionNumbers.push($(this).val());
              });
            return fractionNumbers[0] / fractionNumbers[1] + 1;
          case "American":
            let americanOdds = $(row).find(".selection-odds").val();
            if (americanOdds < 0) {
              return 1 - 100 / americanOdds;
            } else {
              return 1 + americanOdds / 100;
            }
          default:
            return NaN;
        }
      };
    
      const getSelectionOddsAndOutcomes = (rows) => {
        const selectionsOdds = [];
        const outcomes = [];
        let rowsIndex = 0;
    
        rows.map((row) => {
          if ($(row).hasClass("selection-row")) {
            selectionsOdds[rowsIndex] = [];
            const outcome = $(row).find(".selectionOutcome").val();
            outcomes.push(outcome);
            let odds = Number(convertToDecimal(row));
            const eachWayOdds = (placeOdds) => {
              let newOdds = odds;
              newOdds -= 1;
              newOdds *= placeOdds[0];
              newOdds /= placeOdds[1];
              newOdds += 1;
              return newOdds;
            };
            if (applyRuleFour) {
              let deductionAmount = $(row).find(".ruleFourDeduction").val();
              odds--;
              odds *= 1 - deductionAmount / 100;
              odds++;
            }
            switch (outcome) {
              case "WINNER":
                selectionsOdds[rowsIndex][0] = odds;
                if (applyEachWay) {
                  let placeOdds = $(row).find(".eachWayOddsList").val().split("/");
                  selectionsOdds[rowsIndex][1] = eachWayOdds(placeOdds);
                }
                break;
              case "PLACED":
                selectionsOdds[rowsIndex][0] = 0;
                if (applyEachWay) {
                  let placeOdds = $(row).find(".eachWayOddsList").val().split("/");
                  selectionsOdds[rowsIndex][1] = eachWayOdds(placeOdds);
                }
                break;
              case "LOST":
                selectionsOdds[rowsIndex][0] = 0;
                if (applyEachWay) {
                  selectionsOdds[rowsIndex][1] = 0;
                }
                break;
              case "VOID_NON_RUNNER":
                selectionsOdds[rowsIndex][0] = 1;
                if (applyEachWay) {
                  selectionsOdds[rowsIndex][1] = 1;
                }
                break;
              case "DEAD_HEAT":
                let deadHeatValue = Number(
                  $(row).next().find(".dead-heat-list-box").val()
                );
    
                if (
                  applyEachWay &&
                  $(row).next().find(".tied-position-list-box").val() !== "1"
                ) {
                  selectionsOdds[rowsIndex][0] = 0;
                } else {
                  selectionsOdds[rowsIndex][0] = odds / deadHeatValue;
                }
    
                if (applyEachWay) {
                  let placeOdds = $(row).find(".eachWayOddsList").val().split("/");
                  const ewOdds = eachWayOdds(placeOdds);
    
                  let placesOffered = Number(
                    $(row).next().find(".places-offered-list-box").val()
                  );
                  let tiedPosition = Number(
                    $(row).next().find(".tied-position-list-box").val()
                  );
                  let freePlaces = placesOffered - tiedPosition + 1;
                  let filledPlaces = tiedPosition + deadHeatValue - 1;
                  if (placesOffered < tiedPosition) {
                    selectionsOdds[rowsIndex][1] = 0;
                  } else if (filledPlaces > placesOffered) {
                    selectionsOdds[rowsIndex][1] =
                      (ewOdds * freePlaces) / deadHeatValue; // ewOdds / difference
                  } else {
                    selectionsOdds[rowsIndex][1] = ewOdds;
                  }
                }
              default:
                break;
            }
    
            rowsIndex++;
          }
        });
    
        return [selectionsOdds, outcomes];
      };
    
      const calculateFoldOptions = () => {
        const currentRows = getCurrentRows();
        const [selectionsOdds, outcomes] = getSelectionOddsAndOutcomes(currentRows);
    
        let finalReturn = 0;
        let finalOutlay = 0;
        let finalProfit = 0;
    
        const curretFoldRows = getCurrentFoldRows();
    
        curretFoldRows.map((foldRow) => {
          foldRow = $(foldRow);
          const optionIndex = foldRow.index();
          const typesOfBet = [optionIndex + 1];
          const stake = Number(foldRow.find(".fold-stake").val());
    
          let returnAndBetCount = [];
    
          returnAndBetCount = doTheCalculations(typesOfBet, selectionsOdds, stake);
          const [totalReturnOutput, totalOutlayOutput, profitOutput] =
            getTheOutputResult(stake, returnAndBetCount[0], returnAndBetCount[1]);
    
          if (!isNaN(Number(totalReturnOutput)) && !isNaN(Number(profitOutput))) {
            finalReturn += Number(totalReturnOutput);
            finalProfit += Number(profitOutput);
            finalOutlay += Number(totalOutlayOutput.split(" ")[0]);
          }
    
          foldRow.find(".fold-outlay").text(totalOutlayOutput);
          foldRow.find(".fold-return").text(totalReturnOutput);
          foldRow.find(".fold-profit").text(profitOutput);
        });
    
        $("#profit").text(finalProfit);
        $("#return").text(finalReturn);
        $("#totalOutlay").text(finalOutlay);
      };
  
      const calculateTotalBet = (stake) => {
        totalReturn = 0;
        betCount = 0;
    
        if (betType === "ACCUMULATOR" && $("#foldOptions").val() === "2") {
          calculateFoldOptions();
          return;
        }
    
        const currentRows = getCurrentRows();
        const typesOfBetType = BetTypes[betType].types;
        const [selectionsOdds, outcomes] = getSelectionOddsAndOutcomes(currentRows);
    
        let returnAndBetCount = [];
    
        if (betType === "ALPHABET") {
          returnAndBetCount = calculateForAlphabet(stake, selectionsOdds);
        } else if (betType.startsWith("UNIONJACK")) {
          returnAndBetCount = calculateForUnionJack(stake, selectionsOdds);
        } else {
          returnAndBetCount = doTheCalculations(
            typesOfBetType,
            selectionsOdds,
            stake
          );
        }
    
        totalReturn += returnAndBetCount[0];
        betCount += returnAndBetCount[1];
    
        if (!applyEachWay) {
          applyBookmakerBonuses(betType, outcomes, stake);
        }
        const [totalReturnOutput, totalOutlayOutput, profitOutput] =
          getTheOutputResult(stake, totalReturn, betCount);
    
        $("#return").text(totalReturnOutput);
        $("#totalOutlay").text(totalOutlayOutput);
        $("#profit").text(profitOutput);
      };
    
      const applyAllWinnersBonus = (outcomes) => {
        const voidOrLost = outcomes.filter((outcome) => {
          return outcome === "LOST" || outcome === "VOID_NON_RUNNER";
        });
    
        if (voidOrLost.length === 0) {
          totalReturn += (Number($("#allWinnerBonus").val()) / 100) * totalReturn;
        }
      };
    
      const applyOneLoserBonus = (outcomes) => {
        let lostOutcomesCounter = 0;
        let voidOutcomesCounter = 0;
    
        outcomes.forEach((outcome) => {
          if (outcome === "LOST") {
            lostOutcomesCounter++;
          }
          if (outcome === "VOID_NON_RUNNER") {
            voidOutcomesCounter++;
          }
        });
    
        if (lostOutcomesCounter === 1 && voidOutcomesCounter === 0) {
          totalReturn += (Number($("#oneLoserBonus").val()) / 100) * totalReturn;
        }
      };
    
      const applyOneWinnerConsolation = (outcomes) => {
        let lostOutcomesCounter = 0;
        let voidOutcomesCounter = 0;
    
        outcomes.forEach((outcome) => {
          if (outcome === "LOST") {
            lostOutcomesCounter++;
          }
          if (outcome === "VOID_NON_RUNNER") {
            voidOutcomesCounter++;
          }
        });
    
        if (
          lostOutcomesCounter === outcomes.length - 1 &&
          voidOutcomesCounter === 0
        ) {
          // totalReturn +=
          //   (Number($("#oneWinnerConsolation").val()) );
          //TODO::::::
        }
      };
      
      const applyBookmakerBonuses = (betType, outcomes, stake) => {
        switch (betType) {
          case "ALPHABET":
            applyAllWinnersBonus(outcomes);
          case "LUCKY15":
            applyAllWinnersBonus(outcomes);
            applyOneWinnerConsolation(outcomes, stake);
            break;
          case "LUCKY31":
          case "LUCKY63":
            applyAllWinnersBonus(outcomes);
            applyOneLoserBonus(outcomes);
            applyOneWinnerConsolation(outcomes, stake);
            break;
        }
      };
    
      const getTheOutputResult = (stake, total, numberOfBets) => {
        if (stake <= 0) {
          return ["-", "-", "-"];
        }
    
        if ($("#stakeType").val() === "2") {
          stake /= numberOfBets;
          total /= numberOfBets;
        }
    
        if (stake < 0.01) {
          return [
            "-",
            `min stake is ${0.01 * numberOfBets}(${numberOfBets} bets)`,
            "-",
          ];
        }
    
        return [
          total.toFixed(2),
          numberOfBets * stake +
            " (" +
            numberOfBets +
            " bets of " +
            stake.toFixed(2) +
            ")",
          (total - numberOfBets * stake).toFixed(2),
        ];
    
      };
    
      const calculateForUnionJack = (stake, selectionsOdds) => {
        const unionJackOdds = generateUnionJackGrid(selectionsOdds);
    
        let total = 0;
        let totalNumberOfBets = 0;
    
        unionJackOdds.map((odds) => {
          const [returnAmount, numberOfBets] = doTheCalculations(
            BetTypes[betType].types,
            odds,
            stake
          );
          total += returnAmount;
          totalNumberOfBets += numberOfBets;
        });
    
        return [total, totalNumberOfBets];
      };
    
      const generateUnionJackGrid = (selectionsOdds) => {
        const unionJackOdds = [];
    
        unionJackOdds[0] = selectionsOdds.slice(0, 3);
        unionJackOdds[1] = selectionsOdds.slice(3, 6);
        unionJackOdds[2] = selectionsOdds.slice(6, 9);
        unionJackOdds[3] = [];
        unionJackOdds[4] = [];
        unionJackOdds[5] = [];
        for (let i = 3; i < 6; i++) {
          let j = i - 3;
          unionJackOdds[i].push(selectionsOdds[j]);
          unionJackOdds[i].push(selectionsOdds[j + 3]);
          unionJackOdds[i].push(selectionsOdds[j + 6]);
        }
        unionJackOdds[6] = [];
        unionJackOdds[6].push(selectionsOdds[0]);
        unionJackOdds[6].push(selectionsOdds[4]);
        unionJackOdds[6].push(selectionsOdds[8]);
    
        unionJackOdds[7] = [];
        unionJackOdds[7].push(selectionsOdds[2]);
        unionJackOdds[7].push(selectionsOdds[4]);
        unionJackOdds[7].push(selectionsOdds[6]);
    
        return unionJackOdds;
      };
    
      const calculateForAlphabet = (stake, selectionsOdds) => {
        let total = 0;
        let totalNumberOfBets = 0;
    
        const firstPatentOdds = selectionsOdds.slice(0, 3);
        const secondPatentOdds = selectionsOdds.slice(3, 6);
        const yankeeOdds = selectionsOdds.slice(1, 5);
    
        const [firstPatentTotal, firstPatentBetCount] = doTheCalculations(
          BetTypes["PATENT"].types,
          firstPatentOdds,
          stake
        );
        const [secondPatentTotal, secondPatentBetCount] = doTheCalculations(
          BetTypes["PATENT"].types,
          secondPatentOdds,
          stake
        );
        const [yankeeTotal, yankeeBetCount] = doTheCalculations(
          BetTypes["YANKEE"].types,
          yankeeOdds,
          stake
        );
        const [accumulatorTotal, accumulatorBetCount] = doTheCalculations(
          BetTypes["ACCUMULATOR"].types,
          selectionsOdds,
          stake
        );
    
        total =
          firstPatentTotal + secondPatentTotal + yankeeTotal + accumulatorTotal;
        totalNumberOfBets =
          firstPatentBetCount +
          secondPatentBetCount +
          yankeeBetCount +
          accumulatorBetCount;
    
        return [total, totalNumberOfBets];
      };
    
      const doTheCalculations = (typesOfBetType, selectionsOdds, stake) => {
        let total = 0;
        let numberOfBets = 0;
        let combinationLength = 0;
        typesOfBetType.map((type) => {
          if (type === 0) {
            //it means that the betType is Accumulator
            combinationLength = selectionsOdds.length;
            type = combinationLength;
          }
          if (type === "SSA" || type === "DSA") {
            combinationLength = 2;
            type = combinationLength;
            const [combineTotal, combineNumberOfBets] = makeCombination(
              selectionsOdds,
              type,
              0,
              stake,
              combinationLength,
              true
            );
            total += combineTotal;
            numberOfBets += combineNumberOfBets;
            return;
          }
          combinationLength = type;
          const [combineTotal, combineNumberOfBets] = makeCombination(
            selectionsOdds,
            type,
            0,
            stake,
            combinationLength
          );
          total += combineTotal;
          numberOfBets += combineNumberOfBets;
        });
        return [total, numberOfBets];
      };
    
      $("#stake, #allWinnerBonus, #oneLoserBonus").on("change, keyup", () => {
        calculateTotalBet(getStake());
      });
    
      $("#stakeType, #oneWinnerConsolation").on("change", () => {
        calculateTotalBet(getStake());
      });
    
      $("#showNotes").on("change", () => {
        for (let i = 0; i < oddsSelectionRows.length; i += 3) {
          if ($("#showNotes").val() === "1") {
            $(oddsSelectionRows[i]).hide();
            $(oddsSelectionRows[i + 1])
              .find(".row-num-outcome")
              .show();
          } else {
            $(oddsSelectionRows[i]).show();
            $(oddsSelectionRows[i + 1])
              .find(".row-num-outcome")
              .hide();
          }
        }
        showRows();
      });
    
      $("#oddsFormat").on("change", () => {
        let formatValue = $("#oddsFormat").val();
        oddsSelectionRows.map((row) => {
          if (formatValue === "Fractions") {
            $(row).find(".selection-odds").parent().hide();
            $(row).find(".selection-odds-fraction").parent().show();
          } else {
            $(row).find(".selection-odds-fraction").parent().hide();
            $(row).find(".selection-odds").parent().show();
          }
        });
        showRows();
        calculateTotalBet(getStake());
      });
    
      $("#multipleEachWayListBox, #anyToComeEachWayListBox").on("change", () => {
        calculateTotalBet(getStake());
      });
    
      $("#rule4ListBox").on("change", () => {
        if ($("#rule4ListBox").val() == 1) {
          hideTableOption("Rule 4", "ruleFourDeduction");
          applyRuleFour = false;
        } else {
          showTableOption("Rule 4", "ruleFourDeduction");
          applyRuleFour = true;
        }
        calculateTotalBet(getStake());
      });
    
      $("#eachWayListBox").on("change", () => {
        if ($("#eachWayListBox").val() == 1) {
          hideTableOption("Place Odds", "eachWayOddsList");
          oddsSelectionRows.map((row) => {
            $(row).find(".selectionOutcome [value='PLACED']").remove();
            $(row).find(".placesOffered").hide();
            $(row).find(".tiedPosition").hide();
          });
          applyEachWay = false;
        } else {
          showTableOption("Place Odds", "eachWayOddsList");
          oddsSelectionRows.map((row) => {
            $(row)
              .find(".selectionOutcome option:first-child")
              .after("<option value='PLACED'>Placed</option>");
            $(row).find(".placesOffered").show();
            $(row).find(".tiedPosition").show();
          });
          applyEachWay = true;
        }
        showRows();
        calculateTotalBet(getStake());
      });
    
      hideTableOption("Rule 4", "ruleFourDeduction");
      hideTableOption("Place Odds", "eachWayOddsList");
    
      $("#selectionCount").on("change", () => {
        numberOfRows = $("#selectionCount").val();
        showRows();
        calculateTotalBet(getStake());
      });
    
      $("#foldOptions").on("change", function () {
        if ($("#foldOptions").val() === "1") {
          $(".fold-table").hide();
          $("#stake").parent().show();
          return;
        }
        $(".fold-table").show();
        $("#stake").parent().hide();
    
        calculateTotalBet(getStake());
      });
          
      $("#betTypeSelectionBox").on("change", () => {
        betType = $("#betTypeSelectionBox").val();
        if (betType === "ACCUMULATOR" || betType === "DOUBLE") {
          if (numberOfRows < 2) {
            numberOfRows = 2;
            showRows();
          }
          $("#selectionCount option[value='1']").remove();
          if ($("#selectionCount option[value='2']").length === 0) {
            $("#selectionCount").prepend("<option value='2'>2</option>");
          }
        } else if (betType === "TREBLE") {
          $("#selectionCount option[value='1']").remove();
          $("#selectionCount option[value='2']").remove();
          if (numberOfRows < 3) {
            numberOfRows = 3;
            showRows();
          }
        } else {
          if (
            $("#selectionCount option[value='2']").length === 0 &&
            $("#selectionCount option[value='1']").length === 0
          ) {
            $("#selectionCount").prepend("<option value='2'>2</option>");
            $("#selectionCount").prepend("<option value='1'>1</option>");
          } else if (
            $("#selectionCount option[value='1']").length === 0 &&
            $("#selectionCount option[value='2']").length === 1
          ) {
            $("#selectionCount").prepend("<option value='1'>1</option>");
          }
        }
    
        if (betType === "ACCUMULATOR" && $("#foldOptions").val() === "2") {
          $("#stake").hide();
          $(".fold-table").show();
        } else {
          $("#stake").show();
          $(".fold-table").hide();
        }
    
        showSelections();
        showEachWayOptions();
    
        if (BetTypes[betType].numberOfRows != -1) {
          numberOfRows = BetTypes[betType].numberOfRows;
          $("#selectionCount").val(numberOfRows);
          showRows();
        }
        calculateTotalBet(getStake());
      });
    
      $(document).on(
        "change keyup",
        ".selectionOutcome, .selection-odds, .selection-odds-fraction",
        function () {
          calculateTotalBet(getStake());
        }
      );
    
      $(".main-selections-table").on("change", ".selectionOutcome", function () {
        if ($(this).val() === "DEAD_HEAT") {
          $(this).parent().parent().next().show();
        } else if ($(this).val() === "WINNER") {
          // $(this)
          //   .parent()
          //   .nextAll()
          //   .each(function () {
          //     if (!$(this).is(":visible")) {
          //       $(this).show();
          //     }
          //   });
          $(this).parent().parent().next().hide();
        } else {
          // $(this)
          //   .parent()
          //   .nextAll()
          //   .each(function () {
          //     if ($(this).is(":visible")) {
          //       $(this).hide();
          //     }
          //   });
          $(this).parent().parent().next().hide();
        }
    
        if ($(this).val() === "LOST" || $(this).val() === "VOID_NON_RUNNER") {
          $(this).parent().next().first().hide();
        } else {
          $(this).parent().next().first().show();
        }
      });
    
      $("#eachWayListBox").on("change", () => {
        eachWayOption = $("#eachWayListBox").val();
        showEachWayOptions();
        showSelections(); //We need to update the bonuses cause they are not available when eachway is ENABLED
      });
    
      $(".main-selections-table").on(
        "change",
        ".dead-heat-list-box, .ruleFourDeduction, .eachWayOddsList, .tied-position-list-box, .places-offered-list-box",
        () => {
          calculateTotalBet(getStake());
        }
      );
    
      $(".fold-table").on("change, keyup", ".fold-stake", function () {
        calculateFoldOptions();
      });

      $("#reset-calculator").click(function(){

        var selectionOdds = $('.calculator-wrapper select').toArray();
        selectionOdds.map(function (item) {
          $(item).val($(item).find('option:first').val()).trigger('change');
        });

        var inputOdds = $('.calculator-wrapper input').toArray();
        inputOdds.map(function (item) {
          $(item).val('');
        });

        $('.results-table td').text('-');

      });

  });
